// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"cY-z","inlineTitle":"dY-z","sponsoredAdsWrapper":"eY-z","marketplaceRecosWrapper":"fY-z"};